import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_POINTS_EARN_CALCULATION } from 'actions/apiActionConstants'
import { requestLoyaltyEarnPointsCalculationPostPurchase } from 'api/loyalty/requestLoyaltyEarnPointsCalculation'
import batchRequestLoyaltyEarnPointsCalculation from 'api/loyalty/batchRequestLoyaltyEarnPointsCalculation'
import buildPointsKey from 'loyalty/lib/pointsCalculation/buildPointsKey'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import { getHasLuxPlusOrSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscription'
import { SHOULD_AUTOBATCH } from '@reduxjs/toolkit'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

function submitLoyaltyPointsEarnCalculationRequest(
  calculationRequest: App.LoyaltyPointsEarnCalculationRequest,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const customerId = state.auth.account.memberId ?? ''
    const currency = calculationRequest.currency ?? state.geo.currentCurrency
    const pointsEarnCalculationKey = buildPointsKey(calculationRequest, customerId)
    const existingCalculation = state.loyalty.pointsEarnCalculations[pointsEarnCalculationKey]
    const hasLuxPlusOrSubscriptionInCart = getHasLuxPlusOrSubscriptionInCart(state)
    const hasLoyaltyAccount = getHasLoyaltyAccount(state)
    const isCurrentRegionUserLoyaltyRegion = getIsCurrentRegionUserLoyaltyRegion(state)

    if (
      !getIsLoyaltyEnabled(state) ||
      (hasLoyaltyAccount && !isCurrentRegionUserLoyaltyRegion) ||
      existingCalculation?.data ||
      existingCalculation?.fetching ||
      existingCalculation?.error
    ) return

    const baseOptions = {
      customerId,
      currency,
      luxPlusMember: hasLuxPlusOrSubscriptionInCart,
    }

    // Use cart mode to determine if this is a post-purchase checkout
    const isPostPurchase = !!findPostPurchaseCheckout(state.checkout.cart.mode)

    const { orderItemId, orderId } = calculationRequest

    // Even though the request is for a post-purchase item, we still need to check if the orderItemId and orderId as post purchase is not garanteed to be an update operation
    const request = isPostPurchase && orderItemId && orderId
      ? () => requestLoyaltyEarnPointsCalculationPostPurchase(calculationRequest, {
          ...baseOptions,
          orderItemId: orderItemId,
          orderId: orderId,
        })
      : () => batchRequestLoyaltyEarnPointsCalculation({ request: calculationRequest, key: pointsEarnCalculationKey }, baseOptions)

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_POINTS_EARN_CALCULATION,
      pointsEarnCalculationKey,
      meta: {
        [SHOULD_AUTOBATCH]: true,
      },
      request,
    })
  }
}

export default submitLoyaltyPointsEarnCalculationRequest
